import React from 'react';
import TripHeader from './TripHeader';
import TotalDistanceCard from './TotalDistanceCard';
import LastKnownLocationCard from './LastKnownLocationCard';
import ShipmentDetailsCard from './ShipmentDetailsCard';
import ContactCard from './ContactCard';
import RouteTimeline from './RouteTimeline';
import CommentsCard from './CommentsCard';
import TripActions from './TripActions';
import styles from '../TripTrackingV2.module.scss';

const driverName = (driver) => (driver.firstName || driver.lastName)
  ? `${driver.firstName || ''} ${driver.lastName || ''}`.trim()
  : (driver.name || '-');

const TripDetailsPanel = ({ trip }) => (
  <div className={styles.detailsPane}>
    <TripHeader trip={trip} />

    <TotalDistanceCard distance={trip.distance} />

    <LastKnownLocationCard trip={trip} />

    <ShipmentDetailsCard trip={trip} />

    {(trip.driverDetails || []).map((driver, index) => (
      <ContactCard
        key={driver.number || index}
        title="Driver details"
        icon="/images/person.svg"
        name={driverName(driver)}
        lines={[driver.number]}
        consentStatus={driver.consentStatus}
      />
    ))}

    {trip.transporter_details && (
      <ContactCard
        title="Transporter details"
        icon="/images/truck.svg"
        name={trip.transporter_details.name}
        lines={[trip.transporter_details.email, trip.transporter_details.number]}
      />
    )}

    {trip.vehicleDetails && (
      <ContactCard
        title="Vehicle details"
        icon="/images/truck.svg"
        name={trip.vehicleDetails.vehicleNo}
        lines={[
          trip.vehicleDetails.loadingCapacity
            ? `${trip.vehicleDetails.vehicleServiceType}: ${trip.vehicleDetails.loadingCapacity}L`
            : null,
          trip.vehicleDetails.vehicleType,
          trip.vehicleDetails.bodyType,
        ]}
      />
    )}

    <CommentsCard comments={trip.comments} />

    <RouteTimeline routeMap={trip.routeMap} />

    <TripActions trip={trip} />
  </div>
);

export default TripDetailsPanel;
